<template src="./index.html">
</template>
<script>
import xgzz from './xgzz/index.vue'
import lsc from './lsc/index.vue'
export default {
  name: 'hztj',
  components: {
	  xgzz,
	  lsc
  },
  data: function() {
    return {
		chooseindex:0,
		taballData:[
			{
				label:"相关资质"
			},
			{
				label:"增值税执行差异"
			},
		],
    };
  },
  created() {
  },
  methods: {
	  chooseindexs(e){
		  this.chooseindex = e
	  },
  }
};
</script>


<style scoped lang="less">
@import url('./index.less');
</style>
